// Importations nécessaires
import { fetchQuery, useClientQuery } from 'react-relay';
import HomePage from '@/components/pages/home.js';
import { initEnvironment } from '../relay';
import {
 getCached, setCache, getPending, setPending,
} from '@/helpers/cache';
import cookie from '@/helpers/cookie.js';

export async function getServerSideProps(context) {
  const locale = context.locale || 'en';
  const i18n = await import('../i18n.js');
  const tradFromServer = await i18n.getByPages({ routes: ['*', '/'], locale });

  const Component = await import('@/components/pages/home.js');
  const { query, queryVariables } = Component;

  const category = context?.category || 'production';
  const variables = { ...queryVariables({ route: category }), lang: locale };

  const token = cookie.getTokenConnection(context) ?? null;
  const environment = initEnvironment({ token: token || undefined });
  let fromCached = true;
  let data;

  try {
    const cachedKey = {
      query,
      variables,
      token,
    };
    const dataCached = getCached(cachedKey);
    if (!dataCached) {
      let pendingFetch = getPending(cachedKey);
      if (!pendingFetch) {
        pendingFetch = fetchQuery(environment, query, variables, { force: true }).toPromise();
        setPending(cachedKey, pendingFetch);
      }
      await pendingFetch;
      data = environment.getStore().getSource().toJSON();
      // Ne pas mémoriser un store vide (fetch en échec silencieux) : le cache dure 2 h.
      if (Object.keys(data || {}).length > 1) setCache(cachedKey, data);
      fromCached = false;
    } else {
      data = dataCached;
    }
    // console.log('Data fetched successfully:', data);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
  console.log('fromCached', fromCached);
  const queryRecords = data || {};

  return {
    props: {
      query,
      variables,
      animateHeader: true,
      componentPage: 'home',
      queryRecords,
      tradFromServer,
      locale,
    },
  };
}

export default function Home({ variables, query }) {
  const data = useClientQuery(query, variables);
  return (<HomePage {...data} {...{ variables }} />);
}
